import 'js/main/plugin/jquery.mask.min';

export {};



// WEBPACK FOOTER //
// ./js/main/module/masked-input/module.js